<template>
  <div class="http-trigger">
    <div class="row">
      <div class="row-title">URL</div>
      <div class="row-tip">
        用来接收请求的URL
      </div>
      <div class="row-body" style="display: flex;align-items: center">
        <el-input :value="url" disabled style="margin-right: 5px"></el-input>
        <el-button @click="copyUrl">复制链接</el-button>
      </div>
    </div>
    <div class="row">
      <div class="row-title">配置参数列表</div>
      <div class="row-tip">
        系统将根据配置的参数列表来获取请求中的数据
      </div>
      <div class="row-body">
        <output-params ref="outputParams" :output-params="nodeInfo.body"></output-params>
      </div>
    </div>
    <div class="row">
      <div class="row-title">返回响应</div>
      <div class="row-tip">
        工作流出现错误时候的响应值
      </div>
      <div class="row-body">
        <el-input type="textarea" v-model="nodeInfo.response"></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import OutputParams from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/OutputParams"
import { copyToClipBoard } from "@/utils/common"
export default {
  name: "http-trigger",
  components: { OutputParams },
  computed: {
    url() {
      return location.origin + "/api/public/workflow/" + this.workflowId
    }
  },
  data() {
    return {
      nodeInfo: {}
    }
  },
  props: {
    workflowId: String,
    initialNodeInfo: Object
  },
  created() {
    // 设置默认值
    this.nodeInfo = Object.assign(
      {
        body: null,
        response: '{"code":1,"msg":"err"}'
      },
      this._.cloneDeep(this.initialNodeInfo)
    )
  },
  methods: {
    output() {
      if (!this.$refs.outputParams.validate()) return null
      this.nodeInfo.body = this.$refs.outputParams.getValue()
      return this.nodeInfo
    },
    copyUrl() {
      copyToClipBoard(this.url)
      this.$message.success("复制成功")
    }
  }
}
</script>

<style lang="scss" scoped>
.http-trigger {
  .row {
    font-size: 13px;
    padding-bottom: 10px;
    .row-title {
      font-weight: bold;
    }
    .row-tip {
      color: #9e9e9e;
    }
    .row-body {
      margin-top: 10px;
    }
  }
}
</style>
